import problemTab from "./modules/problemTab"
import setParameter from "./modules/setParameter"
import swiper from "./modules/swiper"
import faqAccordion from "./modules/faqAccordion"
import navAccordion from "./modules/navAccordion"
import megaMenu from "./modules/megaMenu"
import hamburgerMenu from "./modules/hamburgerMenu"
import scrollHeader from "./modules/scrollHeader"
import floatingCta from "./modules/floatingCta"
import lazyLoadingVideo from "./modules/lazyLoadingVideo"
import smoothScroll from "./modules/smoothScroll"
import contactFormValidation from "./modules/contactFormValidation"
import worksFilter from "./modules/worksFilter"
import snsLinkShare from "./modules/snsLinkShare"

jQuery(function ($) {
  $(window).on("load", function () {
    // ユーザID生成
    setParameter()

    new WOW().init();
  })
})

document.addEventListener('DOMContentLoaded', function() {
  lazyLoadingVideo();
  swiper();
  hamburgerMenu();
  problemTab();
  faqAccordion();
  megaMenu();
  navAccordion();
  smoothScroll();
  contactFormValidation();
  worksFilter();
  snsLinkShare();
});

window.addEventListener('scroll', () => {
  if (window.innerWidth >= 768) {
    scrollHeader();
  } else {
    floatingCta();
  }
});

const tocButton = document.querySelector('.toc_title');
const tocList = document.querySelector('.toc_list');
if (tocList) {
  let contentHeight = tocList.scrollHeight;

  // 初期状態では目次を開いた状態にする
  tocList.style.maxHeight = contentHeight + 'px';

  tocButton.addEventListener('click', () => {
    if (tocList.style.maxHeight !== '0px') {
      tocList.style.maxHeight = '0px';
      tocButton.classList.add('close');
      tocList.classList.add('close');
    } else {
      tocList.style.maxHeight = contentHeight + 'px';
      tocButton.classList.remove('close');
      tocList.classList.remove('close');
    }
  });
}
